import { registerLuaDefinition } from "../CodeEditor";
import { FloorConfig, LiftConfig } from "./missionConfig";

export enum LiftStatus {
    IDLE = 'IDLE',
    MOVING = 'MOVING',
}
registerLuaDefinition(`
--- @enum LiftStatus
LiftStatus = {
    IDLE = 'IDLE',
    MOVING = 'MOVING'
}
`);

export enum LiftCallDirection {
    UP,
    DOWN,
}
registerLuaDefinition(`
--- @enum LiftCallDirection
LiftCallDirection = {
    UP = 0,
    DOWN = 1
}
`);

export type LiftCallRequestType = 'direction' | 'floor' | 'single';
registerLuaDefinition(`
--- @alias LiftCallRequestType "'direction'" | "'floor'" | "'single'"
`);

export interface LiftCallDirectionData {
    requestedDirection: LiftCallDirection;
}
registerLuaDefinition(`
--- @class LiftCallDirectionData
--- @field requestedDirection LiftCallDirection
`);

export interface LiftCallFloorData {
    requestedFloor: number;
}
registerLuaDefinition(`
--- @class LiftCallFloorData
--- @field requestedFloor number
`);

export interface LiftCallRequest {
    requestId: string;
    requestType: LiftCallRequestType;
    requestData: LiftCallDirectionData | LiftCallFloorData | null;
}
registerLuaDefinition(`
--- @class LiftCallRequest
--- @field requestId string
--- @field requestType LiftCallRequestType
--- @field requestData LiftCallDirectionData | LiftCallFloorData | nil
`);

export interface VisitorState {
    targetFloor: number;
    currentLift: string | null;
    weight: number;
    generationEnter: number;
}
registerLuaDefinition(`
--- @class VisitorState
--- @field targetFloor number
--- @field currentLift string | nil
--- @field weight number
--- @field generationEnter number
`);

export interface FloorState {
    visitors: string[];
    requests: LiftCallRequest[];
    config: FloorConfig;
}
registerLuaDefinition(`
--- @class FloorState
--- @field visitors string[]
--- @field requests LiftCallRequest[]
--- @field config FloorConfig
`);

export interface LiftState {
    currentFloor: number;
    targetedFloors: number[];
    status: LiftStatus;
    passengers: string[];
    requests: LiftCallRequest[];
    config: LiftConfig;
}
registerLuaDefinition(`
--- @class LiftState
--- @field currentFloor number
--- @field targetedFloors number[]
--- @field status LiftStatus
--- @field passengers string[]
--- @field requests LiftCallRequest[]
--- @field config LiftConfig
`);

export interface BuildingState {
    visitors: {
        [visitorId: string]: VisitorState;
    }
    lifts: {
        [liftId: string]: LiftState;
    }
    floors: {
        [floorNumber: number]: FloorState;
    };
}
registerLuaDefinition(`
--- @class BuildingState
--- @field visitors table<string, VisitorState>
--- @field lifts table<string, LiftState>
--- @field floors table<number, FloorState>
`);

export interface SimulationState {
    generation: number;
    building: BuildingState;
    completedTrips: { generationEnter: number, generationLeave: number }[];
}
registerLuaDefinition(`
--- @class SimulationState
--- @field generation number
--- @field building BuildingState
--- @field completedTrips { generationEnter: number, generationLeave: number }[]
`);